import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { dashboardService } from '../services/dashboard';

const STORAGE_KEY = 'osrouter_selected_project';

const ProjectContext = createContext(null);

export function ProjectProvider({ children }) {
  const [projects, setProjects] = useState([]);
  const [selectedHash, setSelectedHash] = useState(() => localStorage.getItem(STORAGE_KEY) || '');

  const loadProjects = useCallback(() => {
    dashboardService.projects(
      (res) => {
        const list = res.data.projects || [];
        setProjects(list);
        if (!selectedHash && list.length > 0) {
          const def = list.find((p) => p.is_default) || list[0];
          setSelectedHash(def.hash);
          localStorage.setItem(STORAGE_KEY, def.hash);
        }
      },
      console.error,
    );
  }, [selectedHash]);

  useEffect(() => {
    loadProjects();
  }, [loadProjects]);

  const setSelectedProject = (hash) => {
    setSelectedHash(hash);
    localStorage.setItem(STORAGE_KEY, hash);
  };

  const selectedProject = useMemo(
    () => projects.find((p) => p.hash === selectedHash) || projects[0] || null,
    [projects, selectedHash],
  );

  const value = useMemo(
    () => ({
      projects,
      selectedProject,
      selectedHash: selectedProject?.hash || selectedHash,
      setSelectedProject,
      reloadProjects: loadProjects,
    }),
    [projects, selectedProject, selectedHash, loadProjects],
  );

  return <ProjectContext.Provider value={value}>{children}</ProjectContext.Provider>;
}

export function useProject() {
  const ctx = useContext(ProjectContext);
  if (!ctx) throw new Error('useProject must be used within ProjectProvider');
  return ctx;
}
